<template>
    <div v-if="isLoaded && isHaveAgency">
        <AgencySlider
            :agency="agencyList"
            @changeAgency="changeAgency($event)"
        ></AgencySlider>
    </div>
</template>

<script>
import Account from "@/helper/AccountHelper.js";
import BzbsAgency from "@/service/BzbsAgency.js"
import AgencySlider from './Agency/AgencySlider.vue';
export default {
    name: 'Agency',
    components: {
        AgencySlider
    },
    props: {
        config: String,
    },
    data: function () {
        return {
            agencyList: [],
            isLoaded: false,
            isHaveAgency: false,
        }
    },
    created: function () {
        this.blobConfig = Account.getCacheBlob()
    },
    methods: {
        initialAgency: function () {
            var token = Account.getToken();
            BzbsAgency.apiGetAgency(token, this.config).then((data) => {
                    for ( var agency of data) {
                        this.agencyList.push(agency)
                    }

                    this.isLoaded = true;
                    this.isHaveAgency = this.agencyList.length > 0
                        ? true
                        : false;

                }).catch((error) => {
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    console.log(error);
                });
        },
        changeAgency: function (agency) {
            this.$emit('changeAgency', agency);
        },
    }
}
</script>

<style>

</style>
